export * from './login.component';


// WEBPACK FOOTER //
// ./src/app/app-modules/login/index.ts